export default "/images/Opportunity3.png?a2f863179123134028fe82b67e74e9a9";